import { render, staticRenderFns } from "./phoneverifier.vue?vue&type=template&id=1dd2c7ac&"
import script from "./phoneverifier.vue?vue&type=script&lang=js&"
export * from "./phoneverifier.vue?vue&type=script&lang=js&"
import style0 from "./phoneverifier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports